export const PAGE_NAME = {
  DEFAULT: 'default',
  EVENT_BENEFIT: 'event-benefit',
  HOME: 'home',
  CARD_GROUP: 'card-group', // 카드 상세 페이지
  CARD_NOT_FOUND: 'card-not-found'
} as const;

export interface MobileStatusBarColor {
  dark: string;
  light: string;
}

export const STATUS_BAR_COLOR = {
  [PAGE_NAME.DEFAULT]: {
    dark: '#000000',
    light: '#ffffff'
  },
  [PAGE_NAME.EVENT_BENEFIT]: {
    dark: '#1a1a1a',
    light: '#f5f5f5'
  },
  [PAGE_NAME.HOME]: {
    dark: '#080808',
    light: '#F5F5F5'
  },
  [PAGE_NAME.CARD_GROUP]: {
    dark: '#202020',
    light: '#ffffff'
  },
  [PAGE_NAME.CARD_NOT_FOUND]: {
    dark: '#080808',
    light: '#ffffff'
  }
} as const;
